export default function filterTreeAccordingToSearchTerm(allItems, searchTerm) {
    // console.log("from filter tree", allItems, searchTerm)
    if (!searchTerm) return allItems;
    const lowerCase = searchTerm.toLowerCase();
    return allItems.map((item) => {
        const nameMatch = item.name.toLowerCase().includes(lowerCase);
        if (nameMatch) return item;
        if (!item.subMenu) return null;

        const children = filterTreeAccordingToSearchTerm(item.subMenu, searchTerm);
        return children.length > 0 ? { ...item, subMenu: children } : null;
    }).filter(Boolean);
}